import * as React from "react";
import { JSX } from "react/jsx-runtime";
const WarningIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.57514 3.21684L1.51681 15.0002C1.37128 15.2522 1.29428 15.5379 1.29346 15.8289C1.29265 16.12 1.36805 16.4061 1.51216 16.6589C1.65627 16.9118 1.86408 17.1225 2.1149 17.27C2.36571 17.4176 2.65081 17.497 2.94181 17.5002H17.0585C17.3495 17.497 17.6346 17.4176 17.8854 17.27C18.1362 17.1225 18.344 16.9118 18.4881 16.6589C18.6322 16.4061 18.7076 16.12 18.7068 15.8289C18.706 15.5379 18.629 15.2522 18.4835 15.0002L11.4251 3.21684C11.2766 2.97193 11.0674 2.76944 10.8178 2.62891C10.5682 2.48838 10.2866 2.41455 10.0001 2.41455C9.71369 2.41455 9.43208 2.48838 9.18248 2.62891C8.93287 2.76944 8.7237 2.97193 8.57514 3.21684V3.21684Z"
      stroke="#004E9B"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 7.5V10.8333"
      stroke="#004E9B"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 14.1665H10.0083"
      stroke="#004E9B"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default WarningIcon;
